<timepicker [(ngModel)]="timeInput"
            [ngModelOptions]="{standalone: true}"
            (click)="detectChanges()"
            (blur)="customPropagateTouch()"
            [id] = "getId()"
            [disabled]="config.editable===false"
            [minuteStep]=1
            #timepicker>
</timepicker>
